
const lang = {
  en: {
    heading: "GPT Search",
    search: "Search",
    gptSearchPlaceholder: "What would you like to watch today?",
    gptMovieSuggestion: "GPT Movie Suggestion"
  },
  hindi: {
    heading: "GPT सर्च",
    search: "खोज",
    gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे?",
    gptMovieSuggestion: "GPT मूवी सुझाव"
  },
  spanish: {
    heading: "Búsqueda con GPT",
    search: "buscar",
    gptSearchPlaceholder: "¿Qué te gustaría ver hoy?",
    gptMovieSuggestion: "Sugerencia de película de GPT"
  },
  korean: {
    heading: "GPT 검색",
    search: "찾다",
    gptSearchPlaceholder: "오늘 무엇을 보고 싶으신가요?",
    gptMovieSuggestion: "GPT 영화 추천"
  },
}

export default lang;